import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import {
  Select, Divider, Drawer,
} from 'antd';
import ExpenseActions from '@Actions/purchase/expense/expenseActions';
import H3Text from '@Uilib/h3Text';
import H3Image from '@Uilib/h3Image';
import closeIcon from '@Images/icons/icon-close-blue.png';
import TallyPrime from '@Images/admin/integrations/tally-prime.png';
import ExpenseAccountForm from './ExpenseAccountForm';

import './style.scss';
import PRZSelect from '../UI/PRZSelect';

const SelectExpenseAccount = ({
  user, showError, tenantId, containerClass, inputClassName, labelClassName, title, hideTitle, notRequired, disabled, getPopupContainer, customStyle, onChange, dropdownAlign, getAccount, showAddExpenseAccount, accounts, expenseAccount,
}) => {
  const [showAddExpenseAccountModal, setShowAddExpenseAccountModal] = useState(false);
  useEffect(() => {
    getAccount(user?.tenant_info?.tenant_id);
  }, []);
  // const TallyExpenseAccounts = user?.tenant_info?.tally_configuration?.ledger_account_list || [];
  const ExpenseAccounts = accounts?.account?.accounts || [];
  const expenseAccounts = [...ExpenseAccounts];

  return (
    <div className={`${containerClass}` || 'orgInputContainer'}>
      <Drawer
        open={showAddExpenseAccountModal}
        onClose={() => setShowAddExpenseAccountModal(false)}
        width="320px"
        destroyOnClose
      >
        <div className="custom-drawer__header-wrapper">
          <div className="custom-drawer__header" style={{ width: '270px' }}>
            <H3Text text="Add Expense Account Type" className="custom-drawer__title" />
            <H3Image src={closeIcon} className="custom-drawer__close-icon" onClick={() => setShowAddExpenseAccountModal(false)} />
          </div>
        </div>
        <ExpenseAccountForm
          callback={(createdAccount) => {
            getAccount(user?.tenant_info?.tenant_id, '', '', '', (newAccounts) => {
              onChange(newAccounts?.account?.accounts?.filter((account) => account?.account_id === createdAccount?.account_id)[0]);
              setShowAddExpenseAccountModal(false);
            });
          }}
        />
      </Drawer>
      {!hideTitle ? (
        <div className={labelClassName || 'orgFormLabel'}>
          {title || 'Expense Account'}
          {!notRequired && <span style={{ color: 'red' }}>{'  *'}</span>}
        </div>
      ) : <label />}
      <div className={inputClassName || 'orgFormInput input'}>
        <PRZSelect
          value={expenseAccount}
          filterOption={true}
          getPopupContainer={getPopupContainer ? (triggerNode) => triggerNode.parentNode : false}
          placeholder="Select Expense Account.."
          disabled={disabled}
          onChange={(value) => {
            onChange(expenseAccounts?.filter((item) => (item?.account_id === value))?.[0]);
          }}
          style={customStyle}
          showSearch
          dropdownRender={
            showAddExpenseAccount ? (menu) => (
              <React.Fragment>
                {menu}
                <Divider style={{ margin: '0px' }} />
                <div className="add__expense-account" onClick={() => setShowAddExpenseAccountModal(true)}>
                  + Add Expense Account
                </div>
              </React.Fragment>
            ) : false
          }
          options={expenseAccounts?.map((item) => ({
            label: <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <div>{item?.account_name || item?.ledger_account_name}</div>
              {item?.ledger_account_name && (
                <div><img
                  src={TallyPrime}
                  alt="Tally"
                  style={{ width: '20px', marginRight: '8px' }}
                /></div>
              )}
            </div>,
            value: item?.account_id,
          }))}
          showError={showError}
          errorName="*Please select an expense account"
          errorClassName="input-error"
        />
      </div>
    </div>
  );
};

const mapStateToProps = ({ UserReducers, ExpenseReducers }) => ({
  user: UserReducers.user,
  accounts: ExpenseReducers.accounts,
});

const mapDispatchToProps = (dispatch) => ({
  getAccount: (tenantId, page, limit, searchKeyword, callback) => dispatch(ExpenseActions.getAccount(tenantId, page, limit, searchKeyword, callback)),
});

SelectExpenseAccount.propTypes = {
  user: PropTypes.any,
  accounts: PropTypes.any,
  showAddExpenseAccount: PropTypes.bool,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  getAccount: PropTypes.func,
  showError: PropTypes.bool,
  title: PropTypes.any,
  hideTitle: PropTypes.bool,
  containerClass: PropTypes.any,
  inputClassName: PropTypes.any,
  labelClassName: PropTypes.string,
  getPopupContainer: PropTypes.bool,
  customStyle: PropTypes.any,
  dropdownAlign: PropTypes.any,
  notRequired: PropTypes.bool,
  tenantId: PropTypes.any,
  expenseAccount: PropTypes.any,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(SelectExpenseAccount));
